import {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ColumnListItem} from "../../../atoms/ColumnListItem";
import {HOTLINE_TILE_PHONE_NUMBER} from "../../../hotline/constants/hotline_phone_numbers";
import {ILeadModalPriceConversationConsultant} from "../../../lead/types/ILeadModalPriceConversationConsultant";
import {getRandomConsultant} from "../../../lead/utils/get_random_consultant";

export function HotlineInfoTile() {
    const [consultant, setConsultant] = useState<ILeadModalPriceConversationConsultant | null>(null);
    const phoneNumber = phoneNumberFormat(HOTLINE_TILE_PHONE_NUMBER);

    const {isMobile} = useUserDevice();

    useEffect(() => {
        setConsultant(getRandomConsultant());
    }, []);

    if (!consultant) return null;

    return (
        <ColumnListItem>
            <div className={container}>
                <Text variant="headline_4" align="center" mb={2}>
                    Masz problem ze znalezieniem mieszkania?
                </Text>

                <Text variant="info_txt_1" align="center" mb={4}>
                    Po krótkiej rozmowie ze mną, <strong>otrzymasz listę nieruchomości</strong> dopasowanych do Twoich preferencji i potrzeb.
                </Text>

                <Image src={consultant.image.s144} className={containerImage} width="156" height="156" alt={consultant.fullName} />

                <Text variant="headline_4" align="center">
                    {consultant.fullName}
                </Text>

                <Text variant="info_txt_1" align="center" mb={2}>
                    Konsultant mieszkaniowy
                </Text>

                {isMobile ? (
                    <Button variant="filled_primary" iconLeft={PhoneIcon} href={`tel:+${phoneNumber}`}>
                        {phoneNumber}
                    </Button>
                ) : (
                    <div className={phoneContainer}>
                        <PhoneIcon size="2.16" wrapperSize="3.6" wrapperColor="var(--colors-primary)" />
                        <Text variant="body_copy_0" strong>
                            {phoneNumber}
                        </Text>
                    </div>
                )}
            </div>
        </ColumnListItem>
    );
}

const container = css({
    backgroundColor: "var(--colors-warning)",
    borderRadius: 2,
    py: 26,
    px: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: 375,

    md: {
        py: 44,
        px: 4
    }
});

const containerImage = css({
    borderRadius: "100%",
    mb: 2
});

const phoneContainer = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1
});
import {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {PhoneIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ColumnListItem} from "../../../atoms/ColumnListItem";
import {HOTLINE_TILE_PHONE_NUMBER} from "../../../hotline/constants/hotline_phone_numbers";
import {ILeadModalPriceConversationConsultant} from "../../../lead/types/ILeadModalPriceConversationConsultant";
import {getRandomConsultant} from "../../../lead/utils/get_random_consultant";

export function HotlineInfoTile() {
    const [consultant, setConsultant] = useState<ILeadModalPriceConversationConsultant | null>(null);
    const phoneNumber = phoneNumberFormat(HOTLINE_TILE_PHONE_NUMBER);

    const {isMobile} = useUserDevice();

    useEffect(() => {
        setConsultant(getRandomConsultant());
    }, []);

    if (!consultant) return null;

    return (
        <ColumnListItem>
            <div className={container}>
                <Text variant="headline_4" align="center" mb={2}>
                    Masz problem ze znalezieniem mieszkania?
                </Text>

                <Text variant="info_txt_1" align="center" mb={4}>
                    Po krótkiej rozmowie ze mną, <strong>otrzymasz listę nieruchomości</strong> dopasowanych do Twoich preferencji i potrzeb.
                </Text>

                <Image src={consultant.image.s144} className={containerImage} width="156" height="156" alt={consultant.fullName} />

                <Text variant="headline_4" align="center">
                    {consultant.fullName}
                </Text>

                <Text variant="info_txt_1" align="center" mb={2}>
                    Konsultant mieszkaniowy
                </Text>

                {isMobile ? (
                    <Button variant="filled_primary" iconLeft={PhoneIcon} href={`tel:+${phoneNumber}`}>
                        {phoneNumber}
                    </Button>
                ) : (
                    <div className={phoneContainer}>
                        <PhoneIcon size="2.16" wrapperSize="3.6" wrapperColor="var(--colors-primary)" />
                        <Text variant="body_copy_0" strong>
                            {phoneNumber}
                        </Text>
                    </div>
                )}
            </div>
        </ColumnListItem>
    );
}

const container = css({
    backgroundColor: "var(--colors-warning)",
    borderRadius: 2,
    py: 26,
    px: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: 375,

    md: {
        py: 44,
        px: 4
    }
});

const containerImage = css({
    borderRadius: "100%",
    mb: 2
});

const phoneContainer = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1
});
